import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * ScrollToTop
 * On standard page transitions (PUSH / REPLACE), resets scroll to top (0, 0).
 * On POP (Back / Forward button), restores the exact previous scroll position.
 */
export default function ScrollToTop() {
    const { pathname, search, hash, key } = useLocation();
    const navType = useNavigationType();
    const scrollPositions = useRef({});

    // Record scroll position before route changes
    useEffect(() => {
        const handleScroll = () => {
            scrollPositions.current[key] = window.scrollY;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [key]);

    useEffect(() => {
        // If navigating to an in-page hash anchor (e.g. #hero-section), jump to that element
        if (hash) {
            const el = document.getElementById(hash.replace('#', ''));
            if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
                return;
            }
        }

        if (navType === 'POP') {
            const savedPosition = scrollPositions.current[key];
            if (typeof savedPosition === 'number') {
                window.scrollTo({ top: savedPosition, left: 0, behavior: 'instant' });
            }
        } else {
            // Forward navigation (PUSH / REPLACE) - always start from the very top
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        }
    }, [pathname, search, hash, navType, key]);

    return null;
}
